import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PurchaseRequisitionListComponent } from './purchase-requisition-list/purchase-requisition-list.component';
import { PurchaseRequisitionDetailComponent } from './purchase-requisition-detail/purchase-requisition-detail.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IimCardModule, IimPaginationModule, IimSpinnerModule, IimTableModule } from '@iim-angular/components';
import {
    BadgeModule,
    BaseSiteLayoutModule,
    DayjsModule,
    DefineVariableModule,
    DisplayCurrencyModule,
    FormatDateRangeModule,
    HighlightModule,
    MobileModule,
    ProcessedStatusDisplayModule,
    PurchaseRequisitionOrderStatusDisplayComponent,
    PurchaseRequisitionDeliveryStatusDisplayComponent,
    PurchaseRequisitionStatusDisplayComponent,
    StringPreviewModule,
} from '@lib/util';
import { PurchaseRequisitionPreviewComponent } from './purchase-requisition-list/purchase-requisition-item-preview/purchase-requisition-preview.component';
import { DemandModule } from '../demand/demand.module';
import { UnitModule } from '@lib/unit';
import { PurchaseRequisitionSupplierPreviewComponent } from './purchase-requisition-list/purchase-requisition-supplier-preview/purchase-requisition-supplier-preview.component';
import { PersonModule } from '@lib/user';
import { ActivityDisplayModule } from '@lib/comment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CopyToClipboardModule, FileDownloadModule, PdfPreviewComponent } from '@lib/core';
import { MatBadgeModule } from '@angular/material/badge';
import { PurchaseRequisitionTaskHintComponent } from './purchase-requisition-task-hint/purchase-requisition-task-hint.component';
import { FeatureActiveDirective } from '@lib/feature-toggle';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { MatDialogModule } from '@angular/material/dialog';
import { PurchaseRequisitionPdfUploadDialogComponent } from './purchase-requisition-list/dialog/purchase-requisition-pdf-upload-dialog.component';
import { PdfSupplierSelectionDialogComponent } from './purchase-requisition-list/dialog/pdf-supplier-selection-dialog/pdf-supplier-selection-dialog.component';
import { SupplierContactNamePipe, SupplierDisplayNamePipe } from '@lib/supplier';

@NgModule({
    declarations: [
        PurchaseRequisitionListComponent,
        PurchaseRequisitionDetailComponent,
        PurchaseRequisitionPreviewComponent,
        PurchaseRequisitionSupplierPreviewComponent,
        PurchaseRequisitionTaskHintComponent,
        PurchaseRequisitionPdfUploadDialogComponent,
        PdfSupplierSelectionDialogComponent,
    ],
    imports: [
        CommonModule,
        DisplayCurrencyModule,
        RouterModule,
        TranslateModule,
        IimTableModule,
        BaseSiteLayoutModule,
        DefineVariableModule,
        StringPreviewModule,
        DemandModule,
        UnitModule,
        BadgeModule,
        PersonModule,
        MobileModule,
        ActivityDisplayModule,
        CopyToClipboardModule,
        FormatDateRangeModule,
        FormsModule,
        IimPaginationModule,
        MatBadgeModule,
        IimCardModule,
        IimSpinnerModule,
        DayjsModule,
        ProcessedStatusDisplayModule,
        PurchaseRequisitionOrderStatusDisplayComponent,
        PurchaseRequisitionDeliveryStatusDisplayComponent,
        PurchaseRequisitionStatusDisplayComponent,
        HighlightModule,
        FeatureActiveDirective,
        SupplierDisplayNamePipe,
        NgxDropzoneModule,
        FileDownloadModule,
        MatDialogModule,
        ReactiveFormsModule,
        PdfPreviewComponent,
        SupplierContactNamePipe,
    ],
    exports: [PurchaseRequisitionDetailComponent],
})
export class PurchaseRequisitionModule {}
